module.exports = __webpack_public_path__ + "img/3.0d6a2bef.webp";